// extracted by mini-css-extract-plugin
export default {"field":"Account_field__ubD8S","customerId":"Account_customerId__TvNpt","email":"Account_email__CUXDJ","accordionContainer":"Account_accordionContainer__WGphB"};